import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Components
import ResetPassword from './ResetPassword.js';

const UpdatePassword = observer(class UpdatePassword extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <main className="page wrap">
        <div className="panel--brief">
          <h1 className="panel__title">{translation.heading}</h1>

          <p className="note note--prominent">{translation.body}</p>

          <ResetPassword
            {...this.props}
            checkValidity={checkValidity}
            standalone={true}
          />
        </div>
      </main>
    )
  }
})

export default translate('UpdatePassword')(UpdatePassword);



// WEBPACK FOOTER //
// ./src/app/components/Account/UpdatePassword.js